/**
 * Created by taylor.houston on 11/1/2018.
 */
export const FACET_GROUP_TOGGLE = 'FACET_GROUP_TOGGLE'
export const FACET_GROUP_EXPAND = 'FACET_GROUP_EXPAND'
export const FACET_GROUP_ADD = 'FACET_GROUP_ADD'
export const FACET_GROUP_BUILD = 'FACET_GROUP_BUILD'
